module.exports = __webpack_public_path__ + "img/feedback8-3.58d83e50.jpg";